import { useInView } from "react-intersection-observer";

import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";
import getPriceList from "@/lib/centra/getPriceList";
import { useAddToCart } from "@/lib/hooks/useAddToCart";
import useCart from "@/lib/hooks/useCart";
import useSelection from "@/lib/hooks/useSelection";

import UI from "./UI";

type ProductDetailsProps = NonNullable<VariantPage["info"]> & {
  addPriceAndSize: any;
  gtagAddToCart: () => void;
};

const ProductDetails = (info: ProductDetailsProps) => {
  const { details, addPriceAndSize, gtagAddToCart } = info;
  const { addToCart } = useAddToCart();

  const observer = useInView();
  const cart = useCart();
  const { priceList } = useSelection();
  const addCallback = () => {
    if (details?.stock && details.itemId) {
      addToCart.mutate({
        itemId: details.itemId,
        cartItem: addPriceAndSize(
          details.itemId,
          getPriceList(details.prices || [], +priceList).price
        ),
      });
      cart.openCart();
      gtagAddToCart();

      return;
    }
    console.error("No stock or itemId");
  };

  return (
    <>
      <UI {...info} observer={observer} addToCart={addCallback} />
    </>
  );
};

export default ProductDetails;
